import { render, staticRenderFns } from "./tongbuKj.vue?vue&type=template&id=0498ce96&scoped=true"
import script from "./tongbuKj.vue?vue&type=script&lang=js"
export * from "./tongbuKj.vue?vue&type=script&lang=js"
import style0 from "./tongbuKj.vue?vue&type=style&index=0&id=0498ce96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0498ce96",
  null
  
)

export default component.exports